export default "__VITE_ASSET__b2621b2d__"